import { useContext } from "react";

import { BoardTemplatesContext } from "./BoardTemplatesContext";

export const useBoardTemplates = () => useContext(BoardTemplatesContext);
